import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { UserService } from 'shared/domain';
import { TreetopPropertiesProvider } from 'shared/util-common';

import { ResourceTag, UserDto } from '@treetop/shared/model';

import { GuidelineGetOptions } from './guidelines.http.service';
import { createGuidelineParams } from './guidelines.http.service.util';

@Injectable({
  providedIn: 'root',
})
export class GuidelinesFilterHttpService {
  private http = inject(HttpClient);
  private userService = inject(UserService);

  private baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api`;

  public getAuthorsOfGuidelines(): Observable<UserDto[]> {
    return this.userService.currentUser$.pipe(
      switchMap((currentUser) => {
        const params = new HttpParams()
          .set('includeSharedGuidelines', false)
          .set('publishedGuidelinesOnly', false)
          .set('organisationId', currentUser.currentOrganisation.id);

        return this.http.get<UserDto[]>(`${this.baseUrl}/users/authors-of-guidelines/`, { params });
      }),
    );
  }

  public getOwnersOfGuidelines(): Observable<UserDto[]> {
    return this.userService.currentUser$.pipe(
      switchMap((currentUser) => {
        const params = new HttpParams()
          .set('includeSharedGuidelines', false)
          .set('publishedGuidelinesOnly', false)
          .set('organisationId', currentUser.currentOrganisation.id);

        return this.http.get<UserDto[]>(`${this.baseUrl}/users/owners-of-guidelines/`, { params });
      }),
    );
  }

  public getUsedResourceTags(options?: GuidelineGetOptions): Observable<ResourceTag[]> {
    const params = createGuidelineParams({ page: 1, itemsPerPage: 1 }, options); // We only need the filter parameters, pagination is irrelevant here

    return this.http.get<ResourceTag[]>(`${this.baseUrl}/guidelines/used-resource-tags`, { params });
  }

  public getUsedSmartbookResourceTags(): Observable<ResourceTag[]> {
    return this.http.get<ResourceTag[]>(`${this.baseUrl}/smart-book/used-resource-tags`);
  }
}
